import React from 'react'
import { Avatar } from '@mui/material'
import { FunctionField } from 'react-admin'
import { AvatarFieldProps, FunctionFieldRender } from './type'
import get from 'lodash/get'
import { imageUrlConcat } from '../../utils/url-concat'

export const AvatarField: React.FC<AvatarFieldProps> = ({ source: targetSource, ...props }) => {
  const render: FunctionFieldRender = (record, source) => {
    const src = imageUrlConcat(get(record, source))
    return <Avatar src={src} {...props} />
  }
  return <FunctionField source={targetSource} render={render} />
}
